"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetModal = void 0;
const icons_1 = require("client/components/icons");
const material_ui_1 = require("material-ui");
const react_1 = require("react");
const React = require("react");
require("./modal.less");
class AssetModal extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleCancelClick = () => {
            this.props.onCancel();
        };
    }
    render() {
        const { title = "No title" } = this.props;
        return (React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "modal-background", onClick: this.handleCancelClick }),
            React.createElement("div", { className: "modal-body", style: {
                    width: `${this.props.width}`,
                    height: `${this.props.height}`,
                    maxHeight: `${this.props.maxHeight}`,
                    maxWidth: `${this.props.maxWidth}`,
                    padding: `${this.props.padding}`,
                    top: `${this.props.top}`
                } },
                React.createElement("a", { className: "close-button", onClick: this.handleCancelClick },
                    React.createElement(icons_1.CloseIcon, null)),
                React.createElement(material_ui_1.Typography, { gutterBottom: true, align: "center", variant: "title" }, title),
                this.props.children)));
    }
}
exports.AssetModal = AssetModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/assetModal.tsx
// module id = 3014
// module chunks = 0